import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchBalanceOnHandReportResult = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getBalanceOnHandReportResult',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      filter: payload.params.resultFilter,
    },
  });
  return axios.post(serviceUrl, {
    inputDate: moment(payload.params.inputDate).format('YYYY-MM-DD'),
    impcCodes: payload.params.impcCodes,
  });
};

export default apiFetchBalanceOnHandReportResult;
